import { gql } from "@apollo/client";

export const GET_DYLOG_COMPANY_TYPES = gql`
  query {
    getCompanyTypes {
      data {
        id
        description
      }
      errors {
        message
      }
    }
  }
`;

export const GET_DYLOG_DOCUMENT_TYPES = gql`
  query {
    getDocumentTypes {
      data {
        id
        description
      }
      errors {
        message
      }
    }
  }
`;

export const GET_DYLOG_MUNICIPALITIES = gql`
  query {
    getPaginatedMunicipalities {
      data {
        id
        description
      }
      count
      errors {
        message
      }
    }
  }
`;

export const GET_DYLOG_PROVINCES = gql`
  query {
    getPaginatedProvinces {
      data {
        id
        description
      }
      count
      errors {
        message
      }
    }
  }
`;

export const GET_DYLOG_REGIONS = gql`
  query {
    getPaginatedRegions {
      data {
        id
        description
      }
      count
      errors {
        message
      }
    }
  }
`;

export const GET_DYLOG_FOREIGN_COUNTRIES = gql`
  query {
    getPaginatedForeignCountries {
      data {
        id
        description
      }
      count
      errors {
        message
      }
    }
  }
`;

export const GET_DYLOG_TYPONYMS = gql`
  query {
    getPaginatedTyponyms {
      data {
        id
        description
      }
      count
      errors {
        message
      }
    }
  }
`;

export const GET_ALL_MY_INVOICES = gql`
  query ($options: GetPaginatedUnpaidInvoiceInputType) {
    getMyInvoices(options: $options) {
      errors {
        message
      }
      count
      data {
        id
        invoiceNumber
        date
        total
        totalPayed
        pendingToPay
      }
    }
  }
`;
